export default function interactiveTeaser () {
    const $rootColor = $('.teaser--interactive-color')
    const $rootRooms = $('.teaser--interactive-rooms')


    function selectColor(event) {
        const $root = $('.teaser--interactive-color')
        const elem = $(event.target)
        const color = $(elem).data('colorswitch-color')
        const uri = $(elem).data('colorswitch-href')
        toggleBackground(color);
        setDeepLink(uri);

        function toggleBackground(color) {
            const backgroundElem = $rootColor.find('li.' + color);
            const colorChooserElem = $rootColor.find('button.' + color);
            $rootColor.find('li').removeClass('active');
            $rootColor.find('button').removeClass('active');
            backgroundElem.addClass('active');
            colorChooserElem.addClass('active');
        }

        function setDeepLink(uri) {
            const linkColor = document.getElementById("teaser__interactive--link-color")
            linkColor.setAttribute('href', uri);
        }
    }

    function selectRooms() {
        const elem = $(this).find('option:selected');
        const room = $(elem).data('colorswitch-room')
        const uri = $(elem).data('colorswitch-href')
        toggleBackground(room);
        setDeepLink(uri);

        function toggleBackground(room) {
            const backgroundElem = $rootRooms.find('li.' + room);
            $rootRooms.find('li').removeClass('active');
            backgroundElem.addClass('active');
        }

        function setDeepLink(uri) {
            const link = document.getElementById("teaser__interactive--link-rooms")
            link.setAttribute('href', uri);
        }
    }

    $rootColor.find('button').click(selectColor)
    $rootRooms.find('select').change(selectRooms)
}


// WEBPACK FOOTER //
// ./Private/Scripts/modules/teasers/interactiveTeaser.js